import { render, staticRenderFns } from "./SharePhotosr.vue?vue&type=template&id=40eb0473&"
import script from "./SharePhotosr.vue?vue&type=script&lang=js&"
export * from "./SharePhotosr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports